import * as React from 'react';
import 'url-search-params-polyfill';
import { SearchField } from './form/SearchField';
import { useCustomEventEffect } from './hooks';

export interface ISearchProps {
  clear?: boolean;
  canClear?: boolean;
  disabled?: boolean;
  debounceTimeout?: number;
  target?: string;
  id?: string;
  initialValue?: string;
  width?: string;
  willUpdateUrl?: boolean;
  searchPlaceholderText?: string;
  handleKeyDown?(event: React.KeyboardEvent<HTMLInputElement>): void;
  handleSearch?(searchTerm: string): void;
}

export interface ICustomSearch {
  searchTerm: string;
}

export type ICustomSearchEvent = CustomEvent<ICustomSearch>;

export function Search({
  canClear = false,
  clear = false,
  disabled = false,
  debounceTimeout = 250,
  handleSearch,
  handleKeyDown,
  id = 'search',
  initialValue = '',
  target,
  willUpdateUrl = false,
  width,
  searchPlaceholderText = 'Search...',
}: ISearchProps) {
  const [searchTerm, setSearchTerm] = React.useState<string>(initialValue);
  const [isTableReady, setIsTableReady] = React.useState<boolean>(false);

  if (target) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useCustomEventEffect<void>(`${target}:ready`, () => {
      setIsTableReady(true);
    });
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { dispatch: dispatchSearch } = useCustomEventEffect<ICustomSearch>(`${target}:search`);

    // eslint-disable-next-line react-hooks/rules-of-hooks
    React.useEffect(() => {
      dispatchSearch({ searchTerm });
    }, [searchTerm]);

    // eslint-disable-next-line react-hooks/rules-of-hooks
    React.useEffect(() => {
      if (searchTerm) dispatchSearch({ searchTerm });
    }, [isTableReady]);
  }

  if (handleSearch) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React.useEffect(() => handleSearch(searchTerm), [searchTerm]);
  }

  function handleChange(newSearchTerm) {
    setSearchTerm(newSearchTerm);
  }

  return (
    <SearchField
      id={id}
      {...{ canClear, clear, debounceTimeout, disabled, handleKeyDown, willUpdateUrl, width }}
      handleChange={handleChange}
      placeholder={searchPlaceholderText}
      value={searchTerm}
    />
  );
}

export default Search;
